<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <rect x="4" y="6" width="16" height="12" fill="none" stroke="currentColor" stroke-width="2" />
    </svg>
</template>
